/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2022-11-06 16:28:47
 */
import React from 'react'
import { Layout } from 'antd'

import PageHeader from '@/components/PageHeader'
const { Content } = Layout

const UserManual = () => {
  return (
    <Layout className="UserManual">
      <PageHeader className="Header" title="使用手册" />
      <Content className="content" style={{ backgroundColor: '#FFFFFF' }}>
        <iframe
          style={{
            width: '100%',
            height: '100%',
            background: '#fff'
          }}
          src="https://alidocs.dingtalk.com/i/p/4BYmaEAkoQ463mNA/docs/D1YKdxGX7EqVQQ2AvpqLVe4QrZk95AzP?dontjump=true#"
          frameBorder="0"
        />
      </Content>
    </Layout>
  )
}

export default UserManual
